import GlobalModal from "features/ModalManagement/GlobalModal";
import GlobalNotifications from "features/Notifications/GlobalNotifications";

export default function GlobalComponents() {
  return (
    <>
      <GlobalModal />
      <GlobalNotifications />
    </>
  );
}
